<template>
  <div class="">
      <BreadCrumbs 
      :children="[
        {
          text: `OnBoarding del APP`,
          link: 'onboarding'
        },
        {
          text: $route.params.id == 0 ? 'Nuevo' : `Version ${version}`
        }
      ]"/>

      <div class="card">
        <div class="card-body">

          <input type="file" @change="handlePic" style="display:none;" id="file-input">

          <Loader v-if="loading" />
          <div v-else class="">
            <div class="row">
              <div class="col-12 col-sm-3">
                <div class="form-group">
                  <label for="version">Versión</label>
                  <input 
                    type="text"
                    ref="version" 
                    v-model="version" 
                    name="version" 
                    id="version" 
                    :class="`form-control ${errors.version ? 'is-invalid' :''}`">
                  <small class="invalid-feedback" v-if="errors.version">La Versión es requerida</small>
                </div>
              </div>
              <hr>
            </div>
            <div style="display:flex;flex-wrap:wrap">

              <div class="slide-parent" v-for="slide in slides" :key="slide.position">
                <div class="position">0{{ slide.position }}</div>
                <div class="slide">
                  <div 
                    class="pic-place"
                    :style="slide.photo == '' ? `` : `background-image:url(${slide.photo});`" 
                    @click="selectPic(slide.position)">
                    <span v-if="slide.photo == ''" class="fa fa-camera"></span>
                    <span v-if="slide.uploadProgress && slide.uploadProgress != ''" class="over">{{ slide.uploadProgress }}%</span>
                  </div>
                  <div class="form-group">
                    <label for="">Titulo</label>
                    <input v-model="slide.title" type="text" class="form-control form-control-sm">
                    <small class="green-t">Max 5 palabras</small>
                  </div>
                  <div class="form-group">
                    <label for="">Descripción</label>
                    <textarea v-model="slide.description" class="form-control form-control-sm" cols="10" rows="2"></textarea>
                    <small class="green-t">Max 10 palabras</small>
                  </div>
                </div>
                <div class="slide-buttons">
                  <button class="btn btn-outline-danger btn-sm" @click="removeSlide(slide.position)">Eliminar</button>
                  <button class="btn btn-outline-success btn-sm" @click="addSlide">Agregar Slide</button>
                </div>
              </div>
              
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 text-right">
              <button :disabled="loading" class="btn btn-success" @click="save">Guardar cambios</button>
            </div>
          </div>
        </div>

      </div>

  </div>  
</template>

<script>
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { UtilsService } from '../../services/UtilsService';
import PhotoUploader from '../../commons/PhotoUploader';

export default {
  name: 'OnBoardingForm',
  components: {
    Loader,
    BreadCrumbs
  },
  data(){
    return {
      id: '',
      version: '',
      slides: [],
      loading: false,
      utilsService: new UtilsService(),
      currentPosition: null,
      errors: {
        version: false
      }
    }
  },
  methods: {
    selectPic(position){
      this.currentPosition = position;
      $('#file-input').trigger('click');
    },
    handlePic(e){
      if(e.target.files[0]){
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (r) => {
          const current = this.slides.find(x => x.position == this.currentPosition);
          if(current){
            current.photo = reader.result;
            current.file = file;
          }
        }
      }
    },
    addSlide(){
      const next = this.slides.length === 0 
        ? 1 
        : this.slides.length + 1;
      this.slides.push({
        position: next,
        title: '',
        description: '',
        photo: '',
        file: null,
        uploadProgress: ''
      });
    },
    removeSlide(position){
      this.slides.splice(
        this.slides.findIndex(x => x.position === position),
        1
      );
    },
    async save(){
            
      if(this.version == ''){
        this.errors.version = true;
        this.$refs.version.focus();
        return;
      }
      this.errors.version = false;

      if(this.slides.length === 0){
        this.$helpers.message('Debes crear almenos 1 slide', 'warning');
        return;
      }
      for(let i = 0; i < this.slides.length; i++){
        const current = this.slides[i];
        if(String(current.photo).trim() == ''){
          this.$helpers.toast(`La imagen del slide ${current.position} es requerida`, 'warning');
          break;
        }
        if(String(current.title).trim() == ''){
          this.$helpers.toast(`El titulo del slide ${current.position} es requerido`, 'warning');
          break;
        }
        if(String(current.description).trim() == ''){
          this.$helpers.toast(`La Descripción del slide ${current.position} es requerida`, 'warning');
          break;
        }
      }

      try {
        
        for await(const slide of this.slides){
          if(!slide.file){
            continue;
          }
          const idRef = `NUEVA_${Date.now()}`;
          const image = await PhotoUploader.upload('OnBoarding', idRef, slide.file, (progress) => {
            slide.uploadProgress = progress;
          });
          slide.photo = image.url;
          delete slide.uploadProgress;
          delete slide.file;
        }

        const res = await this.utilsService.saveOnBoarding(
          this.version,
          this.slides
        );

        if(res.ok){
          const message = this.$route.params.id == 0 ? 'OnBoarding creado!' : 'OnBoarding actualizado!';
          this.$helpers.message('Bien', message, 'success');
          setTimeout(() => {
            this.$router.push(`/onboarding`);
          },1200);

        }else{
          this.$helpers.message('Error', res.message, 'error');
        }

      } catch (error) {
        this.$helpers.message('Error', error.message, 'error');
      }

    },
  },
  created(){
    this.addSlide();
  },
  async beforeMount(){
    if(this.$route.params.id == '' ||  this.$route.params.id == 0){
      return;
    }
    this.loading = true;
    try {
      const res = await this.utilsService.getOneOnBoarding(
        this.$route.params.id
      );
      if(res.ok){
        this.version = res.data.version;
        this.slides = res.data.slides;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
    } catch (error) {
      this.$helpers.message('Error', error.message, 'error');
    }
    this.loading = false;
  }
}
</script>

<style scoped>
  .over{
    z-index: 9999;
    width: 70px;
    height: 70px;
    border-radius: 35px;
    background-color: #eee;
    opacity: 0.5;
    font-size: 1.7rem;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .slide-buttons{
    display: flex;
    justify-content: space-between;
    font-size: .54rem;
    width: inherit;
  }
  .slide-buttons button{
    padding: .5rem 1.4rem !important;
  }
  .slide-parent{
    display: flex;
    flex-direction: column;
    width: 240px;
    align-items: center;
    margin-right: 20px;
  }
  .position{
    font-size: 1.1rem;
    font-weight: 800;
  }
  .green-t{
    color: #1FB67F;
  }
  .pic-place{
    width: 225px;
    height: 110px;
    border-radius: 10px;
    background-color: #fff;    
    border: dashed 1.5px #1FB67F;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #1FB67F;
    cursor: pointer;
    background-position: center;
    background-size: contain;
  }
  .slide{
    padding: 30px 10px;
    height: 440px;
    width: 250px;
    border-radius: 10px;
    background-color: #F9FAFC;
    border: dashed 2px #eee;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  @media (max-width:499px) {
    .slide-parent
    ,.slide
    ,.pic-place{
      width: 100%;
    }
  }
</style>